export interface WorkItem {
  id: string;
  title: string;
  originalTitle: string;
  year: number;
  type: "电影" | "电视剧";
  categories: string[];
  genre: string;
  rating: number | null;
  director: string;
  cast: string[];
  synopsis: string;
  description: string;
  tags: string[];
  views: number;
  poster: string;
  backdrop: string;
}

export const works: WorkItem[] = [
  {
    id: "tokyo-night-rain",
    title: "东京夜雨",
    originalTitle: "東京の夜の雨",
    year: 2023,
    type: "电视剧",
    categories: ["drama"],
    genre: "都市情感",
    rating: 8.6,
    director: "山田和也",
    cast: ["松本菜奈", "佐藤健一", "高桥美咲"],
    synopsis: "一场绵延的夜雨，让三个陌生人在东京的同一个夜晚产生了交集，各自隐藏的心事也随雨声渐渐浮出水面。",
    description: "《东京夜雨》以东京深夜为舞台，通过三组看似互不相干的人物，串联起都市生活中关于孤独、选择与原谅的群像故事。编剧没有给出廉价的答案，而是让每个角色在雨的间隙里，学会与自己和解。剧集以克制的镜头语言与留白式对白著称，是近年伦理剧中最具文学气质的作品之一。",
    tags: ["都市", "情感", "群像"],
    views: 45200,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20drama%20poster%20portrait%2C%20a%20young%20woman%20in%20a%20trench%20coat%20standing%20by%20a%20rain%20streaked%20window%20at%20night%2C%20reflective%20thoughtful%20expression%2C%20moody%20deep%20navy%20blue%20and%20warm%20amber%20rim%20light%2C%20atmospheric%20film%20still%2C%20subtle%20grain%2C%20elegant%20negative%20space%2C%20muted%20desaturated%20tones%2C%20high%20detail&width=600&height=900&seq=jpeth-poster-01&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20rainy%20Tokyo%20street%20at%20night%2C%20reflections%20on%20wet%20asphalt%2C%20warm%20amber%20shop%20lights%20against%20deep%20navy%20sky%2C%20lonely%20figure%20with%20umbrella%2C%20atmospheric%20film%20still%20aesthetic%2C%20subtle%20film%20grain%2C%20moody%20muted%20color%20grading%2C%20high%20detail&width=1280&height=720&seq=jpeth-back-01&orientation=landscape",
  },
  {
    id: "silent-family",
    title: "沉默的家",
    originalTitle: "静かな家",
    year: 2021,
    type: "电视剧",
    categories: ["drama"],
    genre: "家庭伦理",
    rating: 8.2,
    director: "小林诚",
    cast: ["田中优子", "渡边修", "山本莉子"],
    synopsis: "父亲退休后，原本和睦的一家人重新聚在同一屋檐下，沉默的餐桌下暗流涌动，每个人都守着不能说出口的秘密。",
    description: "《沉默的家》聚焦一个典型的日本中产家庭，用四集篇幅解剖亲情里的压抑与期待。导演用大量固定长镜记录餐桌、走廊与玄关，让沉默本身成为叙事主角。作品探讨了代际沟通、赡养压力与原生家庭创伤，是家庭伦理题材中难得的冷静之作。",
    tags: ["家庭", "代际", "写实"],
    views: 38100,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20family%20drama%20poster%20portrait%2C%20a%20quiet%20dining%20table%20lit%20by%20a%20single%20warm%20lamp%20with%20an%20empty%20chair%2C%20somber%20emotional%20atmosphere%2C%20deep%20navy%20shadows%20with%20soft%20amber%20glow%2C%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20minimal%20composition%2C%20muted%20tones&width=600&height=900&seq=jpeth-poster-02&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20quiet%20traditional%20Japanese%20living%20room%20at%20dusk%2C%20tatami%20floor%20and%20low%20table%2C%20soft%20amber%20lamp%20glow%20against%20deep%20navy%20shadows%2C%20melancholic%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20muted%20desaturated%20palette%2C%20high%20detail&width=1280&height=720&seq=jpeth-back-02&orientation=landscape",
  },
  {
    id: "her-choice",
    title: "她的选择",
    originalTitle: "彼女の選択",
    year: 2022,
    type: "电影",
    categories: ["movie"],
    genre: "女性题材",
    rating: 8.0,
    director: "中村由纪",
    cast: ["石原里美香", "井上真央子"],
    synopsis: "在事业与家庭之间摇摆的女性，在一个黄昏的十字路口做出了改变一生的决定。",
    description: "《她的选择》用一天的时间跨度，讲述一位女性在人生岔路口的内心挣扎。影片摒弃煽情配乐，以环境声与面部特写推进情绪，冷静而有力地呈现了当代女性在传统期待与自我实现之间的矛盾。结局留白，把判断交给观众。",
    tags: ["女性", "抉择", "人文"],
    views: 29800,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20film%20poster%20portrait%2C%20a%20woman%20in%20a%20coat%20looking%20back%20over%20her%20shoulder%20on%20a%20city%20street%20at%20dusk%2C%20melancholic%20expression%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20atmospheric%20bokeh%20background%2C%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20elegant%20negative%20space&width=600&height=900&seq=jpeth-poster-03&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20quiet%20city%20crosswalk%20at%20dusk%2C%20lone%20woman%20standing%20still%20while%20others%20blur%20past%2C%20deep%20navy%20shadows%20with%20warm%20amber%20streetlight%20glow%2C%20reflective%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20muted%20tones%2C%20high%20detail&width=1280&height=720&seq=jpeth-back-03&orientation=landscape",
  },
  {
    id: "beyond-the-boundary",
    title: "边界之外",
    originalTitle: "境界の外へ",
    year: 2019,
    type: "电影",
    categories: ["movie"],
    genre: "悬疑剧情",
    rating: 7.8,
    director: "黑泽良平",
    cast: ["绫濑遥子", "岡田将生介"],
    synopsis: "一桩发生在深夜的意外，让两个原本毫无交集的家庭被迫面对彼此，真相在反复的回忆中逐渐扭曲。",
    description: "《边界之外》是一部讨论道德灰度的悬疑剧情片。导演用非线性剪辑把同一夜反复呈现三次，每一次都推翻上一次的立场，迫使观众反思“真相”与“叙事”的关系。影片气氛克制压抑，是伦理悬疑类型的重要尝试。",
    tags: ["悬疑", "道德", "非线叙"],
    views: 22100,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20mystery%20drama%20poster%20portrait%2C%20silhouette%20of%20a%20person%20at%20the%20edge%20of%20a%20dimly%20lit%20corridor%2C%20mysterious%20moody%20atmosphere%2C%20deep%20navy%20blue%20shadows%20with%20a%20sliver%20of%20warm%20amber%20light%2C%20film%20noir%20aesthetic%2C%20subtle%20grain%2C%20minimal%20composition&width=600&height=900&seq=jpeth-poster-04&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20long%20empty%20apartment%20corridor%20at%20night%2C%20a%20single%20door%20ajar%20with%20warm%20amber%20light%20spilling%20out%2C%20deep%20navy%20shadows%2C%20suspenseful%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20muted%20palette%2C%20high%20detail&width=1280&height=720&seq=jpeth-back-04&orientation=landscape",
  },
  {
    id: "after-the-rain",
    title: "雨后的关系",
    originalTitle: "雨上がりの関係",
    year: 2020,
    type: "电视剧",
    categories: ["drama"],
    genre: "都市情感",
    rating: 8.4,
    director: "山田和也",
    cast: ["新垣结衣子", "星野源太", "松本菜奈"],
    synopsis: "两个在雨中偶遇的成年人，用一把伞遮住了各自破碎的生活，也在晴天来临前学会了重新开始。",
    description: "《雨后的关系》以细腻的日常对白和四季更替的影像，描绘成年人之间“慢热”的情感。故事拒绝戏剧化的冲突，转而关注陪伴、体谅与安放情绪的能力，被观众称为最治愈的伦理情感剧。",
    tags: ["治愈", "成年人", "日常"],
    views: 51300,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20romance%20drama%20poster%20portrait%2C%20two%20people%20sharing%20an%20umbrella%20on%20a%20wet%20street%20after%20rain%2C%20tender%20quiet%20atmosphere%2C%20deep%20navy%20sky%20with%20warm%20amber%20streetlight%20reflections%2C%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20muted%20desaturated%20palette&width=600&height=900&seq=jpeth-poster-05&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20quiet%20neighborhood%20street%20just%20after%20rain%2C%20clearing%20sky%20with%20deep%20navy%20clouds%20and%20warm%20amber%20sunset%20light%2C%20puddles%20reflecting%20the%20sky%2C%20gentle%20hopeful%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20muted%20tones%2C%20high%20detail&width=1280&height=720&seq=jpeth-back-05&orientation=landscape",
  },
  {
    id: "midnight-cafe",
    title: "深夜咖啡馆",
    originalTitle: "深夜のカフェ",
    year: 2024,
    type: "电视剧",
    categories: ["drama", "latest"],
    genre: "治愈群像",
    rating: 8.8,
    director: "小林诚",
    cast: ["役所广之子", "石原里美香", "高桥美咲"],
    synopsis: "一间只在午夜营业的咖啡馆，接待每一位无处可去的人，用一杯咖啡交换他们不敢说出口的故事。",
    description: "《深夜咖啡馆》是近年最受欢迎的现象级伦理剧。每一集以一位客人为主线，讲述都市边缘人的隐秘情感。剧集以温暖克制的基调，探讨谅解、告别与重新出发，台词被大量观众引用，成为年度口碑黑马。",
    tags: ["治愈", "群像", "口碑"],
    views: 67400,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20drama%20poster%20portrait%2C%20a%20warm%20cozy%20late%20night%20cafe%20interior%20with%20a%20lone%20barista%20behind%20the%20counter%2C%20soft%20amber%20lamplight%20and%20deep%20navy%20shadows%2C%20intimate%20atmosphere%2C%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20elegant%20minimal%20composition&width=600&height=900&seq=jpeth-poster-06&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20narrow%20late%20night%20cafe%20in%20a%20quiet%20alley%2C%20glowing%20warm%20amber%20window%20against%20deep%20navy%20night%2C%20steam%20rising%20from%20a%20cup%2C%20cozy%20intimate%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20muted%20tones%2C%20high%20detail&width=1280&height=720&seq=jpeth-back-06&orientation=landscape",
  },
  {
    id: "flower-and-thorn",
    title: "花与刺",
    originalTitle: "花と棘",
    year: 2018,
    type: "电影",
    categories: ["movie"],
    genre: "情感剧情",
    rating: 7.9,
    director: "中村由纪",
    cast: ["苍井优子", "妻夫木聪志"],
    synopsis: "一段看似完美的关系背后，藏着彼此都不愿直面的伤痕，爱与伤害常常长在同一根枝条上。",
    description: "《花与刺》以花道为隐喻，讲述一对伴侣如何在亲密关系中反复平衡依恋与伤害。影片用极具仪式感的构图画面对照情感的失序，是一部关于“如何相爱”的成人童话。",
    tags: ["情感", "隐喻", "文艺"],
    views: 18700,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20film%20poster%20portrait%2C%20a%20woman%20holding%20a%20single%20red%20flower%20against%20a%20dark%20textured%20wall%2C%20bittersweet%20emotional%20mood%2C%20deep%20navy%20background%20with%20warm%20amber%20highlight%2C%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20refined%20minimal%20composition&width=600&height=900&seq=jpeth-poster-07&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20minimal%20dark%20room%20with%20a%20single%20vase%20of%20flowers%20on%20a%20table%2C%20warm%20amber%20light%20cutting%20through%20deep%20navy%20shadows%2C%20elegant%20moody%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20muted%20palette%2C%20high%20detail&width=1280&height=720&seq=jpeth-back-07&orientation=landscape",
  },
  {
    id: "mothers-notes",
    title: "母亲的手记",
    originalTitle: "母の手記",
    year: 2015,
    type: "电视剧",
    categories: ["drama", "classic"],
    genre: "家庭伦理",
    rating: 9.0,
    director: "山田洋次郎",
    cast: ["树木希林子", "阿部宽太", "田中裕子"],
    synopsis: "母亲去世后，子女在整理遗物时发现一叠手记，重新认识了这个他们以为早已了解的女人。",
    description: "《母亲的手记》被誉为家庭伦理剧的巅峰之作。全剧以手记的逐页展开为线索，温柔而残酷地还原了一位母亲沉默的一生。作品不批判任何人，却让每一位观众在结尾潸然泪下。",
    tags: ["亲情", "经典", "催泪"],
    views: 88900,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20family%20drama%20poster%20portrait%2C%20an%20older%20womans%20hands%20folding%20a%20handwritten%20letter%20on%20a%20wooden%20table%2C%20nostalgic%20warm%20mood%2C%20deep%20navy%20shadows%20with%20soft%20amber%20window%20light%2C%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20intimate%20composition&width=600&height=900&seq=jpeth-poster-08&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20old%20Japanese%20family%20home%20in%20autumn%2C%20warm%20amber%20afternoon%20light%20through%20paper%20screens%2C%20deep%20navy%20shadows%2C%20deeply%20nostalgic%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20muted%20tones%2C%20high%20detail&width=1280&height=720&seq=jpeth-back-08&orientation=landscape",
  },
  {
    id: "old-love-letter",
    title: "旧情书",
    originalTitle: "古いラブレター",
    year: 2008,
    type: "电影",
    categories: ["movie", "classic"],
    genre: "年代爱情",
    rating: 8.7,
    director: "岩井俊三",
    cast: ["中山美穗子", "丰川悦司郎"],
    synopsis: "一封寄错地址的情书，牵出一段尘封多年的旧日往事，让两个时空的人重新相遇。",
    description: "《旧情书》以书信为结构，让过去与现在彼此映照。影片将复古色调与凛冽雪景结合，讲述记忆如何塑造我们的爱与遗憾，是伦理爱情片中的不朽经典。",
    tags: ["年代", "书信", "经典"],
    views: 72300,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20classic%20film%20poster%20portrait%2C%20a%20vintage%20love%20letter%20and%20dried%20flowers%20on%20aged%20paper%2C%20nostalgic%20atmosphere%2C%20deep%20navy%20and%20warm%20sepia%20amber%20tones%2C%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20elegant%20old%20world%20composition&width=600&height=900&seq=jpeth-poster-09&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20snowy%20Japanese%20countryside%20town%20at%20dusk%2C%20old%20wooden%20houses%20with%20warm%20amber%20windows%2C%20deep%20navy%20twilight%20sky%2C%20nostalgic%20romantic%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20muted%20palette%2C%20high%20detail&width=1280&height=720&seq=jpeth-back-09&orientation=landscape",
  },
  {
    id: "tokyo-tower-story",
    title: "东京塔物语",
    originalTitle: "東京タワー物語",
    year: 2006,
    type: "电视剧",
    categories: ["drama", "classic"],
    genre: "家庭年代",
    rating: 8.9,
    director: "山田洋次郎",
    cast: ["倍赏千惠子", "吉冈秀隆介"],
    synopsis: "从昭和到平成，一座东京塔下的一家人，用三十年的平凡岁月书写了不平凡的亲情。",
    description: "《东京塔物语》以一座地标为时间坐标，记录了一个普通家庭的兴衰与离合。剧集节奏舒缓，情感真挚，被誉为日本家庭伦理剧的国民记忆。",
    tags: ["年代", "亲情", "国民"],
    views: 81500,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20classic%20drama%20poster%20portrait%2C%20the%20silhouette%20of%20a%20tower%20rising%20above%20quiet%20residential%20rooftops%20at%20twilight%2C%20nostalgic%20mood%2C%20deep%20navy%20sky%20with%20warm%20amber%20window%20lights%2C%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20minimal%20composition&width=600&height=900&seq=jpeth-poster-10&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20old%20Tokyo%20neighborhood%20with%20a%20tall%20tower%20in%20the%20distance%20at%20dusk%2C%20warm%20amber%20house%20lights%20against%20deep%20navy%20sky%2C%20nostalgic%20sentimental%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20muted%20tones%2C%20high%20detail&width=1280&height=720&seq=jpeth-back-10&orientation=landscape",
  },
  {
    id: "spring-will-come",
    title: "春天会来",
    originalTitle: "春は来る",
    year: 2025,
    type: "电视剧",
    categories: ["drama", "latest"],
    genre: "治愈成长",
    rating: 9.1,
    director: "新海诚二",
    cast: ["广濑铃子", "菅田将晖介", "满岛光"],
    synopsis: "在人生最低谷的冬天，一位女孩回到乡下老家，在慢慢苏醒的春天里，重新学会了相信明天。",
    description: "《春天会来》以四季为章节，用极其细腻的笔触描写治愈的过程。剧集不回避痛苦，却始终给出温柔的出口，是近五年评分最高的伦理成长剧，被观众称作“冬日里的一束光”。",
    tags: ["治愈", "成长", "高分"],
    views: 59200,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20drama%20poster%20portrait%2C%20a%20young%20woman%20standing%20in%20a%20sunlit%20field%20of%20spring%20flowers%20turning%20toward%20the%20light%2C%20hopeful%20gentle%20mood%2C%20deep%20navy%20accents%20with%20warm%20amber%20sunlight%2C%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20airy%20composition&width=600&height=900&seq=jpeth-poster-11&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20sunny%20spring%20countryside%20village%20in%20Japan%2C%20blossoming%20trees%20and%20warm%20amber%20morning%20light%2C%20deep%20navy%20distant%20mountains%2C%20hopeful%20uplifting%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20muted%20soft%20palette%2C%20high%20detail&width=1280&height=720&seq=jpeth-back-11&orientation=landscape",
  },
  {
    id: "second-heartbeat",
    title: "第二次心动",
    originalTitle: "二度目のときめき",
    year: 2024,
    type: "电影",
    categories: ["movie", "latest"],
    genre: "成人爱情",
    rating: 8.3,
    director: "中村由纪",
    cast: ["柴崎幸子", "坂口健太郎介"],
    synopsis: "两个都曾受过伤的中年人，在一次偶然的相遇里，小心翼翼地尝试相信第二次心动。",
    description: "《第二次心动》写给所有不敢再爱的人。影片用大量的静默与眼神交流替代狗血桥段，把成年人之间克制又真挚的情感拍得格外动人，是近年少见的成熟爱情伦理片。",
    tags: ["成人", "爱情", "细腻"],
    views: 43600,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20romance%20film%20poster%20portrait%2C%20two%20strangers%20about%20to%20meet%20at%20a%20crosswalk%20in%20soft%20evening%20light%2C%20romantic%20tentative%20mood%2C%20deep%20navy%20tones%20with%20warm%20amber%20glow%2C%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20elegant%20negative%20space&width=600&height=900&seq=jpeth-poster-12&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20quiet%20city%20evening%20street%20with%20warm%20amber%20lights%20and%20deep%20navy%20sky%2C%20two%20distant%20figures%20walking%20toward%20each%20other%2C%20gentle%20romantic%20film%20still%20aesthetic%2C%20subtle%20grain%2C%20muted%20tones%2C%20high%20detail&width=1280&height=720&seq=jpeth-back-12&orientation=landscape",
  },
];